var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "var(--color-color7)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3106 7.18967C18.5918 7.47096 18.7498 7.85242 18.7498 8.25017C18.7498 8.64791 18.5918 9.02938 18.3106 9.31067L10.8106 16.8107C10.5293 17.0919 10.1479 17.2498 9.75012 17.2498C9.35238 17.2498 8.97091 17.0919 8.68962 16.8107L5.68962 13.8107C5.41639 13.5278 5.26519 13.1489 5.26861 12.7556C5.27203 12.3623 5.42978 11.9861 5.70789 11.7079C5.98601 11.4298 6.36223 11.2721 6.75552 11.2687C7.14882 11.2652 7.52772 11.4164 7.81062 11.6897L9.75012 13.6292L16.1896 7.18967C16.4709 6.90846 16.8524 6.75049 17.2501 6.75049C17.6479 6.75049 18.0293 6.90846 18.3106 7.18967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTick);
export default __webpack_public_path__ + "static/media/checkbox_tick.dcc6333c8df3b13d5c80c0d1926ed61f.svg";
export { ForwardRef as ReactComponent };